<form [formGroup]="form" class="application-form-container" fxLayout="column">

    <div *ngIf="!fileUploaded" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center"
         fxLayoutAlign.lt-md="start start"
         fxLayoutGap="10px" class="main-container stepper pt-20">
        <ng-container *ngFor="let step of STEPS; let i=index">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                <div [ngClass]="currentStep >= i+1 ? 'circle' : 'circle disabled'" fxLayoutAlign="center center">
                    <div class="number" fxLayoutAlign="center center">{{i + 1}}</div>
                </div>
                <div [ngClass]="currentStep >= i+1 ? 'subtitle' : 'subtitle disabled'">
                    {{(step)|i18n}}
                </div>
            </div>
            <div *ngIf="i+1 !== STEPS.length" class="line" fxFlex fxShow.lt-md="false"></div>
            <div *ngIf="i+1 !== STEPS.length" class="bar" fxFlex fxShow.gt-sm="false"></div>
        </ng-container>
    </div>
    <!-- STEP 1-->
    <ng-container *ngIf="currentStep === 1">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm="space-between start"
                 fxLayoutGap.lt-md="30px">
                <span class="text-0">{{"For which period would you like to upload measures?"|i18n}}</span>
            </div>
            <form [formGroup]="customTimeRangeForm" class="mt-20" fxLayout="column">
                <div fxLayout="column" fxLayoutGap="20px">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="txt-p-16-4">
                        <div fxFlex="20" class="txt-p-16-4">{{'Start date and time:'|i18n}}</div>
                        <div app-input-container fxFlex="25" fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="4px">
                            <input app-input [matDatepicker]="startDate"
                                   [min]="startMinDate"
                                   [max]="startMaxDate"
                                   formControlName="startDate">
                            <mat-datepicker-toggle [for]="startDate"></mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                        </div>
                        <div app-input-container fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                             fxFlex="20"
                             class="txt-p-16-4">
                            <input app-input type="number"
                                   [min]="minHour"
                                   [max]="startMaxHour"
                                   formControlName="startHour">
                            <div>:00</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="txt-p-16-4">
                        <div fxFlex="20" class="txt-p-16-4">{{'End date and time:'|i18n}}</div>
                        <div app-input-container fxFlex="25" fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="4px">
                            <input app-input [matDatepicker]="endDate"
                                   [min]="endMinDate"
                                   [max]="endMaxDate"
                                   formControlName="endDate">
                            <mat-datepicker-toggle [for]="endDate"></mat-datepicker-toggle>
                            <mat-datepicker #endDate></mat-datepicker>
                        </div>
                        <div app-input-container fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                             fxFlex="20"
                             class="txt-p-16-4">
                            <input app-input type="number"
                                   [min]="minHour"
                                   [max]="endMaxHour"
                                   formControlName="endHour">
                            <div>:00</div>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="10px">
                        <div *ngIf="customTimeRangeForm.hasError('fromdateAfterTodate')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'End date must follow start date'|i18n}}</div>
                        </div>
                        <div *ngIf="customTimeRangeForm.hasError('startHourOutOfRange')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'Start hour out of range'|i18n}}</div>
                        </div>
                        <div *ngIf="customTimeRangeForm.hasError('endHourOutOfRange')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'End hour out of range'|i18n}}</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>
    <!-- STEP 2-->
    <ng-container *ngIf="currentStep === 2">
        <div fxLayout="row" class="panel" fxLayoutAlign="center center" fxLayoutGap="10px">
            <span class="text-0">{{"Choose a measure unit:"|i18n}}</span>
            <div class="mat-select" fxFlex="30">
                <mat-select formControlName="timeRange" app-small-select (selectionChange)="onSelectTimeFilter($event)">
                    <mat-option *ngFor="let timerange of TIME_RANGES| keyvalue" [value]="timerange.value">
                        {{timerange.key|i18n}}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </ng-container>

    <!-- STEP 3-->
    <ng-container *ngIf="currentStep === 3">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Download the template and fill it with the measures"|i18n}}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center">
                <button app-primary-button
                        (click)="onClickDownloadTemplate()">
                    <app-icon name="fal-download"></app-icon>
                    {{'Download template'|i18n}}
                </button>
            </div>
            <span *ngIf="this.templateDownloaded" fxLayoutAlign="center center" class="txt-s-14-4">
                {{'File downloaded! Proceed with the next step'|i18n}}
            </span>
        </div>

    </ng-container>

    <!-- STEP 4-->
    <ng-container *ngIf="currentStep === 4">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Upload your modified file:"|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span class="txt-p-16-4">{{'Edited file:'|i18n}}</span>
                    <input #fileSelect type="file" style="display: none"
                           [accept]="XLSX_MIME_TYPE"
                           (change)="onClickUploadTemplate($event)">
                    <button app-primary-button
                            (click)="fileSelect.click()">
                        <app-icon [name]="templateChosen ? 'fal-sync' : 'fal-search'"></app-icon>
                        {{(templateChosen ? 'Change file' : 'Select file')|i18n}}
                    </button>
                    <span *ngIf="this.template?.name" class="txt-p-16-4">{{this.template?.name}}</span>
                    <div *ngIf="!this.template.name"
                         class="txt-s-14-4">{{'No file uploaded'|i18n}}</div>
                    <button *ngIf="templateChosen" app-icon-button class="app-button-alert"
                            (click)="onClickTrashTemplate(fileSelect)">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <span fxLayoutAlign="center center" class="txt-s-14-4">
                    {{'(Max {0} MB. Accepts only XLSX files.)'|i18n:MAX_FILE_MB}}
                </span>
            </div>
        </div>

    </ng-container>

    <div fxLayout="row" fxLayoutAlign="space-evenly" class="mt-42">
        <button *ngIf="currentStep === 1" app-ghost-button type="button"
                [mat-dialog-close]="false">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-times"></app-icon>
                <span>{{'Cancel'|i18n}}</span>
            </div>
        </button>
        <button *ngIf="currentStep > 1 && !fileUploaded" app-ghost-button type="button"
                (click)="prevStep()">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-arrow-left"></app-icon>
                <span>{{'Back'|i18n}}</span>
            </div>
        </button>
        <button *ngIf="currentStep < STEPS.length" app-primary-button type="button"
                [disabled]="!isNextEnabled(currentStep)"
                (click)="nextStep()">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                <span>{{'Next'|i18n}}</span>
                <app-icon name="fal-arrow-right" class="right-icon"></app-icon>
            </div>
        </button>
        <button *ngIf="currentStep === STEPS.length" app-primary-button type="button"
                (click)="sendIt()"
                [disabled]="!this.templateChosen"
                [matDialogClose]="true">
            <app-icon name="fal-save"></app-icon>
            {{'Save Data'|i18n}}
        </button>
    </div>

</form>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>